<span>{{data.name}}</span><span style="padding-left: 10px">{{data.property}}</span>
<app-color-tile *ngIf="data.isColorTile" [hexValue]="data.value"></app-color-tile>
<span *ngIf="!data.isColorTile">{{data.value}}</span>